import React from 'react';
import styles from '../../ChargebackProtection.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How a claim works</span>
        <h2>You sell. We handle the fraud.</h2>
        <p className={styles.secLead}>From screening to resolution, Fyntiq does the work behind the scenes.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2 l8 4 v6 c0 5 -3.5 8 -8 10 c-4.5 -2 -8 -5 -8 -10 V6 z" /><path d="M9 12 l2 2 l4 -4" />
            </svg>
          </div>
          <h3>Every payment is screened</h3>
          <p>Fyntiq checks each transaction for fraud signals in real time, before it ever hits your books.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
            </svg>
          </div>
          <h3>A fraudulent dispute hits</h3>
          <p>If a customer falsely disputes a legitimate charge, Fyntiq flags it as a fraud-related claim.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6 L9 17 l-5 -5" />
            </svg>
          </div>
          <h3>We respond &amp; cover it</h3>
          <p>Fyntiq compiles the evidence and responds for you. Eligible claims are covered — you keep the revenue.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
